import React from 'react';
import {
  getCargoDirection,
  getCargoStatus,
  isCargoOverdue,
} from '../../utils/companyShipments';
import { formatShipmentDate, getCarrierLabel, getTrackingUrl } from '../../utils/shipments';
import styles from './LoginReminders.module.css';

/** Giriş hatırlatmasında tek bir bekleyen kargonun özeti. */
const CargoReminderItem = ({ shipment }) => {
  const direction = getCargoDirection(shipment.direction);
  const status = getCargoStatus(shipment.direction, shipment.status);
  const overdue = isCargoOverdue(shipment);
  const carrier = getCarrierLabel(shipment.carrier);
  const trackingUrl = getTrackingUrl(shipment.carrier, shipment.trackingNumber);
  const expected = formatShipmentDate(shipment.expectedAt);
  const title = shipment.subject || shipment.content || direction.label;

  return (
    <li className={`${styles.item} ${styles.cargoItem}`}>
      <div className={styles.cargoItemTop}>
        <span className={styles.itemName} title={title}>{title}</span>
        <span className={`${styles.badge} ${overdue ? styles.badgeUrgent : styles.badgeInfo}`}>
          {overdue ? 'Gecikti' : status.label}
        </span>
      </div>
      <div className={styles.cargoMeta}>
        <span>
          {direction.shortLabel}
          {shipment.partyName ? ` · ${direction.partyLabel}: ${shipment.partyName}` : ''}
        </span>
        {(carrier || shipment.trackingNumber) && (
          <span>
            {carrier}
            {shipment.trackingNumber && (
              <>
                {carrier ? ' · ' : ''}
                {trackingUrl ? (
                  <a
                    href={trackingUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.cargoLink}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {shipment.trackingNumber}
                  </a>
                ) : (
                  shipment.trackingNumber
                )}
              </>
            )}
          </span>
        )}
        {expected && <span>Beklenen: {expected}</span>}
      </div>
    </li>
  );
};

export default CargoReminderItem;
